<div>
    <!-- <button class="global-button" *ngIf="!isAuthenticated" (click)="oktaAuth.loginRedirect()">Login</button>
    <button class="global-button" *ngIf="isAuthenticated" (click)="onLogOutClick()">Logout</button> -->
</div>